/**
 * Payment settlement style.
 * tag: 40227
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentSettlStyle {
  /** Standard */
  Standard = 0,
  /** Net */
  Net = 1,
  /** Standard and net */
  StandardfNet = 2,
}
